/**
 * URL API сервера
 */
export const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8080/api/v1';

/**
 * Типы маркетплейсов
 */
export const MARKETPLACE_TYPES = {
  OZON: 'ozon',
  WILDBERRIES: 'wildberries',
  YANDEX: 'yandex',
} as const;

/**
 * Статусы товаров
 */
export const PRODUCT_STATUSES = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ARCHIVED: 'archived',
} as const;

/**
 * Статусы расхождений
 */
export const DISCREPANCY_STATUSES = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  IGNORED: 'ignored',
} as const;
